import { render, staticRenderFns } from "./complex.vue?vue&type=template&id=56969e19&shadow"
import script from "./complex.vue?vue&type=script&lang=js&shadow"
export * from "./complex.vue?vue&type=script&lang=js&shadow"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports